import React, { Component } from "react";

import "./Dialog.css";

class Dialog extends Component {
    constructor(props) {
        super(props);
    }
    state = {};
    render() {
        let { actions, message, progress } = this.props;
        return (
            <div className="dialogBackground">
                <div className="Dialog">
                    <div className="message">{message}</div>
                    {progress && (
                        <div className="progress">
                            <progress
                                value={progress.current}
                                max={progress.total}
                            ></progress>
                            {`${parseInt(
                                (progress.current / progress.total) * 100
                            )}%`}
                        </div>
                    )}

                    <div className="actions">
                        {actions &&
                            actions.length > 0 &&
                            actions.map((a) => {
                                return (
                                    <button
                                        onClick={a.callback}
                                        className={a.classes}
                                        key={a.text}
                                    >
                                        {a.text}
                                    </button>
                                );
                            })}
                    </div>
                </div>
            </div>
        );
    }
}

export default Dialog;
